import LessonForm from "@/components/forms/planning/LessonForm"
import { router } from "@/main"
import { checkPermissions } from "@/utils/checkPermissions"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { Button, FormStyle, scheduleQueryKeys } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/lessen/nieuwe-les",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({ from: "/beheer/groepen/$groupId" })
  const queryClient = useQueryClient()

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: scheduleQueryKeys.groupDetail(Number(groupId)),
    })
    router.history.back()
  }

  return (
    <FormStyle className="mx-auto">
      <h3 className="text-xl font-bold mb-4 text-center">Nieuwe Les</h3>

      <LessonForm
        type="create"
        groupId={groupId}
        handleSuccess={handleSuccess}
        SubmitButton={(isValid, isPending) => (
          <div className="flex gap-4 justify-end">
            <Button
              variant="secondary"
              type="button"
              onClick={() => {
                router.history.back()
              }}
            >
              Annuleren
            </Button>
            <Button
              disabled={!isValid}
              isLoading={isPending}
              type="submit"
              variant="primary"
            >
              Opslaan
            </Button>
          </div>
        )}
      />
    </FormStyle>
  )
}
